import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { ArrowRight, Filter, tick } from "assets/images/imageData";
import localization from "assets/localization/localization";
import PaymentFilter from "components/sales/ListFilters/PaymentFilter";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import Images from "assets/images/imageData";
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import AdjustAdvancePopup from "components/sales/paymentPortal/adjustAdvance/adjustAdvancePopup";
import ViewDetailsPopup from "components/sales/paymentPortal/viewDetails/viewDetails";

const InvoiceList = ({
  getTaxInvoice,
  postSalesList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  verifyInvoicesNumbers,
  verifyInvoiceNumbersWithRecon = [],
  editClientDetails,
  editClientDetailsForTan = []
}) => {
  const headers = [
    "Site Number",
    "Document Type",
    "Document Number",
    "Document Date",
    "Business",
    "Revenue Nature",
    "Total Amount",
    "Due date",
    "Status",
    "Pending Amount",
    "Late Fee",
    "Document Age",
    "Actions",
  ];
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [showAddPaymentPopup, setShowAddPaymentPopup] = useState(false);
  const [showAdjustAdvancePopup, setShowAdjustAdvancePopup] = useState(false);
  const [showDetailsPopup, setShowDetailsPopup] = useState(false);
  const [currentBusinessId, setCurrentBusinessId] = useState('');
  const [currentInvoiceId, setCurrentInvoiceId] = useState('');
  const [currentContractId, setCurrentContractId] = useState('');
  const [currentSiteNumber, setCurrentSiteNumber] = useState('');
  const [currentBusinessName, setCurrentBusinessName] = useState('');
  const [currentInvoiceNumber, setCurrentInvoiceNumber] = useState('');
  const [currentDocumentType, setCurrentDocumentType] = useState('');
  const [lateFee, setLateFee] = useState('');
  const [lateFeeApplicable, setLateFeeApplicable] = useState('');
  const [dueDate, setDueDate] = useState('');

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem("roles"));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales("post-sales-corporate");
      } else if (teamId && teamId === 9) {
        setActivePostSales("post-sales-supply");
      } else if (teamId && teamId === 8) {
        setActivePostSales("post-sales-apartment");
      } else {
        setActivePostSales("post-sales-b2b-alliance");
      }
    }
  };

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem("profileDetails"))) &&
        JSON.parse(localStorage.getItem("profileDetails"))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  useEffect(() => {
    if (getTaxInvoice !== null) {
      (async () => {
        setIsLoading(true);
        await getTaxInvoice(null, 1);
        setIsLoading(false);
      })();
    }
  }, [getTaxInvoice]);

  useEffect(() => {
    const tableData = [
      "id",
      "site_number",
      "document_type",
      "document_number",
      "document_date",
      "business",
      "revenue_nature",
      "total_amount",
      "due_date",
      "status",
      "pending_amount",
      "late_fee_amount",
      "invoice_age"
    ];

    if (postSalesList !== {} && postSalesList.resultSets) {
      const data = postSalesList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action: [
              { name: "Add Payment", businessId: element?.business_id, businessName: element?.business, invoiceId: element?.document_id, contractId: element?.contract_id, siteNumber: element?.site_number, late_fee_amount: element?.late_fee_amount, is_late_fee_applicable: element?.is_late_fee_applicable,due_date: element?.due_date, invoiceNumber: element?.document_number, documentType: element?.document_type},
              { name: "Advance Adjustment", businessId: element?.business_id, businessName: element?.business, invoiceId: element?.document_id, contractId: element?.contract_id, siteNumber: element?.site_number },
              { name: "View Detail", invoiceId: element?.document_id,     
              }
            ],
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(postSalesList.total / postSalesList.per_page));
    }
  }, [postSalesList]);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getTaxInvoice(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const handleAddPayment = async (invoiceNumber) => {
    console.log("CLICKED: ", invoiceNumber)
    const data = {
      'invoice_number': invoiceNumber,
    }
    setIsLoading(true);
    await verifyInvoicesNumbers(data);
    setIsLoading(false);
  };  

  const headerBtns = () => {
    return (
      <Fragment>
         <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          {/* <img src={Images?.Filter} alt="" /> */}
          {localization.showFilters}
        </Button> 
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getTaxInvoice(filter, val.selected + 1);
    setIsLoading(false);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.taxInv}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={postSalesList && postSalesList.resultSets}
        pageCount={pageCount}
        srNo={postSalesList?.from}
        onPageChange={onPageChange}
        setShowAddPaymentPopup={setShowAddPaymentPopup}
        setShowAdjustAdvancePopup={setShowAdjustAdvancePopup}
        setShowDetailsPopup={setShowDetailsPopup}
        setCurrentBusinessId={setCurrentBusinessId}
        setCurrentContractId={setCurrentContractId}
        setCurrentInvoiceId={setCurrentInvoiceId}
        setCurrentSiteNumber={setCurrentSiteNumber}
        setCurrentBusinessName={setCurrentBusinessName}
        setLateFeeApplicable={setLateFeeApplicable}
        setLateFee={setLateFee}
        setDueDate={setDueDate}
        setCurrentInvoiceNumber={setCurrentInvoiceNumber}
        setCurrentDocumentType={setCurrentDocumentType}
      />

      <PaymentFilter
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={"5"}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        invoiceFilters
      />

      <AddPaymentPopup
        showPaymentPopup={showAddPaymentPopup}
        onClosePopup={() => setShowAddPaymentPopup(false)}
        businessId={currentBusinessId}
        invoiceId={currentInvoiceId}
        invoiceNumber={currentInvoiceNumber}
        documentType={currentDocumentType}
        contractId={currentContractId}
        siteNumber={currentSiteNumber}
        businessName={currentBusinessName}
        lateFee={lateFee}
        lateFeeApplicable={lateFeeApplicable}
        dueDate={dueDate}
        documentUploadUrlPublic={documentUploadUrlPublic}
        documentUrlDataPublic={documentUrlDataPublic}
        verifyInvoicesNumbers={verifyInvoicesNumbers}
        verifyInvoiceNumbersWithRecon={verifyInvoiceNumbersWithRecon}
        editClientDetails={editClientDetails}
        editClientDetailsForTan={editClientDetailsForTan}
      />
      {showAdjustAdvancePopup && <AdjustAdvancePopup
        showAdjustAdvancePopup={showAdjustAdvancePopup}
        onClosePopup={() => setShowAdjustAdvancePopup(false)}
        businessId={currentBusinessId}
        invoiceId={currentInvoiceId}
        contractId={currentContractId}
        siteNumber={currentSiteNumber}
        businessName={currentBusinessName}
      />}
      
      {showDetailsPopup && <ViewDetailsPopup 
        showViewDetailsPopup={showDetailsPopup}
        onClosePopup={() => setShowDetailsPopup(false)}
        invoiceId={currentInvoiceId}
      />}
    </Layout>
  );
};

export default InvoiceList;
